import { TermsTemplateCreate } from "./TermsTemplateCreate";
import { TermsTemplateEdit } from "./TermsTemplateEdit";
import { TermsTemplateList } from "./TermsTemplateList";

export const terms_templates = {
    list: TermsTemplateList,
    create: TermsTemplateCreate,
    edit: TermsTemplateEdit,
    recordRepresentation: "name",
};
